import { useScript } from '../hooks/useScript';
import { isProduction, trackingEnabled } from '../utils/env';

export function TrackingScripts() {
  const measurementId = process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID;

  // 2. Google Analytics / gtag (only when tracking is enabled and measurementId is present)
  useScript({
    id: 'gtag-js',
    src: (trackingEnabled && measurementId) ? `https://www.googletagmanager.com/gtag/js?id=${measurementId}` : '',
    enabled: trackingEnabled && !!measurementId,
    async: true,
  });

  useScript({
    id: 'gtag-config',
    enabled: trackingEnabled && !!measurementId,
    innerHTML: `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${measurementId}', { send_page_view: true });
    `,
  });

  return null;
}
